// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as FileSaver from "file-saver";

function getView(pdfLink) {
  return React.createElement("div", {
              className: "link-component__content"
            }, React.createElement("div", {
                  className: "link-component__title"
                }, "Please click on link below to get your printable TDS declaration"), React.createElement("div", {
                  className: "link-component__link"
                }, React.createElement("button", {
                      onClick: (function (param) {
                          FileSaver.saveAs(pdfLink, "tds_declaration.pdf");
                          
                        })
                    }, "Download")));
}

var TdsPdfViewMapper = {
  getView: getView
};

export {
  TdsPdfViewMapper ,
  
}
/* react Not a pure module */
